import React, { useEffect } from 'react';
import { useAssets, useLocale } from 'hooks';
import { useParams } from 'react-router-dom';
import { Box } from '@material-ui/core';

import { Loader, Page } from 'ui';
import { AssetDetails } from 'ui/assetDetails/AssetDetails';
import { AppRoute } from 'routing/AppRoute.enum';

export const Details = () => {
  const { getAssetById, getAssets } = useAssets();
  const { id } = useParams<{ id: string }>();
  const { formatMessage } = useLocale();
  const asset = getAssetById(id);

  useEffect(() => {
    if (!asset) {
      getAssets();
    }
  }, []);

  const displayContent = () => {
    if (!asset)
      return (
        <Box justifyContent="center">
          <Loader text={formatMessage({ id: 'dashboard.assetsLoading' })} />
        </Box>
      );

    return <AssetDetails {...asset} />;
  };

  return (
    <Page title={formatMessage({ id: 'asset_details.page_title' })} backPage={AppRoute.dashboard}>
      {displayContent()}
    </Page>
  );
};
